import React, { useEffect, useState } from "react";
import { Card, CardBody } from "./../../components/card/card.jsx";
import Pagination2 from "../../components/pagination/pagination2.jsx";
import { Link } from "react-router-dom";

import { planTrainingAll } from "../../config/apiSPA.js";
import DataStatus from "./dataStatus.jsx";
import Pagination3 from "../../components/pagination/pagination3.jsx";
import DateFormat from "../../components/dateFormater/dateFormat1.js";
import DateRangeStatus from "../../components/dateFormater/dateElapse.jsx";

const trainingPresetData = {
  data: [],
  meta: null,
  links: null,
};

function TrainingPlanData() {
  const [allPlanTraining, setAllPlanTraining] = useState(trainingPresetData);
  const [search1Value, setSearch1Value] = useState("");
  function nextClick1(val) {
    loadData(search1Value, allPlanTraining.meta.current_page + 1);
  }
  function prevClick1(val) {
    loadData(search1Value, allPlanTraining.meta.current_page - 1);
  }
  function submitSearch1(e) {
    e.preventDefault();
    loadData(search1Value);
  }
  const loadData = (search = "", page = "") => {
    planTrainingAll(search, page).then((res) => setAllPlanTraining(res));
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <div>
        <div className="d-flex align-items-center mb-3">
          <div>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#/">TRAINING</a>
              </li>
              <li className="breadcrumb-item active">Data</li>
            </ul>

            <h1 className="page-header">
              Training Plan and Monitoring <small></small>
            </h1>
          </div>

          <div className="ms-auto">
            <Link to="/training/plan/new" className="btn btn-outline-theme">
              <i className="fa fa-plus-circle fa-fw me-1"></i> New Plan
            </Link>
          </div>
        </div>

        <hr className="mb-4" />
        <Card>
          <div className="tab-content p-4">
            {/* ----------------All Tab------------------------------------------------------------------ */}
            <div className="tab-pane fade show active" id="allTab">
              <form onSubmit={(e) => submitSearch1(e)}>
                <div className="input-group mb-4">
                  <div className="d-flex justify-content-end">
                    <div className="input-group">
                      <input type="text" onChange={(e) => setSearch1Value(e.target.value)} className="form-control px-35px" placeholder="Search" />
                      <div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0" style={{ zIndex: 1020 }}>
                        <i className="fa fa-search opacity-5"></i>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-outline-default" type="submit">
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </form>

              {/* ----------------Table-------------- */}

              <div className="table-responsive">
                <table className="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th className="border-top-0 pt-0 pb-2">Training Title</th>
                      <th className="border-top-0 pt-0 pb-2">Status</th>
                      <th className="border-top-0 pt-0 pb-2">Location</th>
                      <th className="border-top-0 pt-0 pb-2">Institution</th>
                      <th className="border-top-0 pt-0 pb-2">Instructor</th>
                      <th className="border-top-0 pt-0 pb-2">Plan Date</th>
                      <th className="border-top-0 pt-0 pb-2"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {allPlanTraining.data.length > 0 ? (
                      allPlanTraining.data.map((value, index) => (
                        <tr key={index}>
                          <td className="align-middle">
                            <Link to={"/training/plan/detail/" + value.id}>{value.training.title}</Link>
                          </td>
                          <DataStatus status={value.status} />
                          <td className="align-middle">{value.location.location}</td>
                          <td className="align-middle">{value.institution.institutionName}</td>
                          <td className="align-middle">{value.instructor.namaInstructor}</td>
                          <td className="align-middle">{DateFormat(value.start)}</td>
                          <td className="align-middle">
                            <DateRangeStatus startDate={value.start} endDate={value.end} />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="align-middle">no Data</td>
                        <td className="align-middle"></td>
                        <td className="align-middle"></td>
                        <td className="align-middle"></td>
                        <td className="align-middle"></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* ----------------End Table-------------- */}

              {allPlanTraining.data.length > 0 ? <Pagination3 pageInfo={allPlanTraining} nextClick={(val) => nextClick1(val)} prevClick={(val) => prevClick1(val)} /> : ""}
            </div>
            {/* ----------------End All Tab------------------------------------------------------------------ */}
          </div>
        </Card>
      </div>
    </>
  );
}

export default TrainingPlanData;
